import { render, staticRenderFns } from "./MessageItemView.vue?vue&type=template&id=43e82629&scoped=true&"
import script from "./MessageItemView.vue?vue&type=script&lang=ts&"
export * from "./MessageItemView.vue?vue&type=script&lang=ts&"
import style0 from "./MessageItemView.vue?vue&type=style&index=0&id=43e82629&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e82629",
  null
  
)

export default component.exports